/** Correspondence log for an inspection — every email sent, with status. */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Mail, CheckCircle2, XCircle } from "lucide-react";

export const EmailHistory = ({ inspectionId }) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get(`/inspections/${inspectionId}/emails`)
      .then((r) => setRows(r.data))
      .catch(() => setRows([]));
  }, [inspectionId]);

  if (!rows || rows.length === 0) return null;

  return (
    <div className="border-2 border-slate-200 bg-white mt-6" data-testid="email-history-card">
      <div className="px-4 py-3 border-b-2 border-slate-200 bg-slate-50 flex items-center gap-2">
        <Mail size={14} className="text-teal-700" />
        <h3 className="font-black text-slate-900 text-sm">Correspondence — {rows.length} email{rows.length === 1 ? "" : "s"}</h3>
      </div>
      <div className="divide-y divide-slate-100">
        {rows.map((r) => (
          <div key={r.id} className="px-4 py-2.5 flex items-start gap-3 text-sm" data-testid={`email-log-row-${r.id}`}>
            {r.status === "sent" ? (
              <CheckCircle2 size={15} className="text-emerald-600 mt-0.5 shrink-0" />
            ) : (
              <XCircle size={15} className="text-red-600 mt-0.5 shrink-0" />
            )}
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-slate-900 truncate">{r.subject}</p>
              <p className="text-xs text-slate-500 truncate">
                To {r.to}{r.cc ? ` · cc ${r.cc}` : ""}
                {r.attachments?.length ? ` · ${r.attachments.length} attachment${r.attachments.length === 1 ? "" : "s"}` : ""}
                {r.sent_by_name ? ` · by ${r.sent_by_name}` : ""}
              </p>
              {r.status === "failed" && r.error && (
                <p className="text-xs text-red-600 truncate">Failed: {r.error}</p>
              )}
            </div>
            <div className="text-right shrink-0">
              <span className={`inline-block px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider border ${
                r.status === "sent" ? "bg-emerald-50 text-emerald-800 border-emerald-300" : "bg-red-50 text-red-700 border-red-300"}`}>
                {r.status}{r.via === "own" ? " · own email" : ""}
              </span>
              <p className="text-[11px] text-slate-400 mt-0.5">{r.sent_at ? new Date(r.sent_at).toLocaleString() : ""}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailHistory;
